import zhCNIndex from "./code-index/zh-CN.json";
import enUSIndex from "./code-index/en-US.json";

const FALLBACK_LOCALE = "zh-CN";

const CODE_INDEX = {
  "zh-CN": zhCNIndex,
  "en-US": enUSIndex,
};

function normalizeCode(code) {
  if (code === null || code === undefined) return "";
  return String(code);
}

export function getCodeMessage(code, locale = FALLBACK_LOCALE, fallbackMessage = "") {
  const key = normalizeCode(code);
  if (!key) return fallbackMessage || "";

  const active = CODE_INDEX[locale] || CODE_INDEX[FALLBACK_LOCALE] || {};
  const fallback = CODE_INDEX[FALLBACK_LOCALE] || {};

  return active[key] || fallback[key] || fallbackMessage || "";
}

export default getCodeMessage;
